{
  "title": "Reality Break",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "8th-level conjuration (dunamancy:chronurgy)",
  "level": 8,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a crystal prism)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You shatter the barriers between realities and timelines, thrusting a creature into turmoil and madness. The target must succeed on a Wisdom saving throw, or it can't take reactions until the spell ends. The affected target must also roll a d10 at the start of each of its turns; the number rolled determines what happens to the target as shown on the Reality Break Effects table.",
    "At the end of each of its turns, the affected target can repeat the Wisdom saving throw, ending the spell on itself on a success",
    "Reality Break Effects",
    "d10",
    "Effect",
    "1-2",
    "Vision of the Far Realm. The target takes 6d12 psychic damage, and it is stunned until the end of the turn",
    "3-5",
    "Rending Rift. The target must make a Dexterity saving throw, taking 8d12 force damage on a failed save, or half as much damage on a successful save.",
    "6-8",
    "Wormhole. The target is teleported, along with everything it is wearing and carrying, up to 30 feet to an unoccupied space of your choice that you can see. The target also takes 10d12 force damage and is knocked prone.",
    "9-10",
    "Chill of the Dark Void. The target takes 10d12 cold damage, and it is blinded until the end of the turn."
  ],
  "spellLists": ["wizard"]
}
